/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/widgets/WordsWidget/WordsWidget.tsx
*/

import React, { useEffect, useRef, useState } from 'react';
import { Types } from './types';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

import ChartHelper from '../../charts/BubbleChart/BarChartHelper';

import { Wrapper } from './WordsBubblesWidget.css';
import WordCloud from '../../charts/WordCloud/WordCloud';
import BubbleChart from '../../charts/BubbleChart/BubbleChart';
import { useIsMobile } from '../../../hooks/useIsMobile';

const WordsBubblesWidget = ({ updateContent, isLightsOn }: IWordsBubblesWidgetProps) => {
  const { width, height } = useWindowDimensions();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [data, setData] = useState<Types.WordCloudData[]>([]);

  const dimensionsBubbleChart = useRef() as { current: Types.Dimensions };
  const dimensionsWordCloud = useRef() as { current: Types.Dimensions };

  const isMobile = useIsMobile();

  const dt: Types.WordCloudData[] = [
    {
      id: 0,
      name: 'Blockchain',
      size: 350,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 1,
      name: 'Neoculture',
      size: 100,
      fillColor: '9d9a9f',
      fillColorGrey: '9d9a9f',
    },
    {
      id: 2,
      name: 'Info',
      size: 75,
      fillColor: '605f62',
      fillColorGrey: '605f62',
    },
    {
      id: 3,
      name: 'Engaging',
      size: 150,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 4,
      name: 'Bleeding',
      size: 125,
      fillColor: 'c6c5c6',
      fillColorGrey: 'c6c5c6',
    },
    {
      id: 5,
      name: 'Visuals',
      size: 230,
      fillColor: '808080',
      fillColorGrey: '808080',
    },
    {
      id: 6,
      name: 'Solutions',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 7,
      name: 'Digital',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 8,
      name: 'Designers',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 9,
      name: 'Developers',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 10,
      name: 'Product',
      size: 50,
      fillColor: 'A9A9A9',
      fillColorGrey: 'A9A9A9',
    },
    {
      id: 11,
      name: 'Future',
      size: 60,
      fillColor: 'A9A9A9',
      fillColorGrey: 'A9A9A9',
    },
    {
      id: 12,
      name: 'Smarthome',
      size: 70,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 13,
      name: 'UXD',
      size: 80,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 14,
      name: 'AR',
      size: 90,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 15,
      name: 'Creative',
      size: 100,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 16,
      name: 'Smart',
      size: 150,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 17,
      name: 'Innovators',
      size: 150,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 18,
      name: 'VR',
      size: 350,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 19,
      name: 'Team',
      size: 100,
      fillColor: '9d9a9f',
      fillColorGrey: '9d9a9f',
    },
    {
      id: 20,
      name: 'Artand',
      size: 75,
      fillColor: '605f62',
      fillColorGrey: '605f62',
    },
    {
      id: 21,
      name: 'Frameworks',
      size: 150,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 22,
      name: 'Solutions',
      size: 125,
      fillColor: 'c6c5c6',
      fillColorGrey: 'c6c5c6',
    },
    {
      id: 23,
      name: 'Fashion',
      size: 230,
      fillColor: '808080',
      fillColorGrey: '808080',
    },
    {
      id: 24,
      name: 'Native',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 25,
      name: 'Web design',
      size: 350,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 26,
      name: 'Code',
      size: 100,
      fillColor: '9d9a9f',
      fillColorGrey: '9d9a9f',
    },
    {
      id: 27,
      name: 'Innovate',
      size: 75,
      fillColor: '605f62',
      fillColorGrey: '605f62',
    },
    {
      id: 28,
      name: 'Integrate',
      size: 150,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 29,
      name: 'Launch',
      size: 150,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 30,
      name: 'Web',
      size: 125,
      fillColor: 'c6c5c6',
      fillColorGrey: 'c6c5c6',
    },
    {
      id: 31,
      name: 'Mobile',
      size: 230,
      fillColor: '808080',
      fillColorGrey: '808080',
    },
    {
      id: 32,
      name: 'Systems',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 33,
      name: 'Success',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 34,
      name: 'Digital',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 35,
      name: 'Product',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 36,
      name: 'Partners',
      size: 50,
      fillColor: 'A9A9A9',
      fillColorGrey: 'A9A9A9',
    },
    {
      id: 37,
      name: 'Clients',
      size: 60,
      fillColor: 'A9A9A9',
      fillColorGrey: 'A9A9A9',
    },
    {
      id: 38,
      name: 'Engineers',
      size: 70,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 39,
      name: 'Designer',
      size: 80,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 40,
      name: 'UX',
      size: 90,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 41,
      name: 'UXD',
      size: 100,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 42,
      name: 'Marketplaces',
      size: 150,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 43,
      name: 'Commerce',
      size: 150,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 44,
      name: 'Web design',
      size: 350,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 45,
      name: 'Code',
      size: 100,
      fillColor: '9d9a9f',
      fillColorGrey: '9d9a9f',
    },
    {
      id: 46,
      name: 'Innovate',
      size: 75,
      fillColor: '605f62',
      fillColorGrey: '605f62',
    },
    {
      id: 47,
      name: 'Integrate',
      size: 150,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 48,
      name: 'Launch',
      size: 150,
      fillColor: '02eaec',
      fillColorGrey: 'D3D3D3',
    },
    {
      id: 49,
      name: 'Web',
      size: 125,
      fillColor: 'c6c5c6',
      fillColorGrey: 'c6c5c6',
    },
    {
      id: 50,
      name: 'Mobile',
      size: 230,
      fillColor: '808080',
      fillColorGrey: '808080',
    },
    {
      id: 51,
      name: 'Systems',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 52,
      name: 'Success',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 53,
      name: 'Digital',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 54,
      name: 'Product',
      size: 70,
      fillColor: 'e0b7a0',
      fillColorGrey: 'C0C0C0',
    },
    {
      id: 55,
      name: 'Partners',
      size: 50,
      fillColor: 'A9A9A9',
      fillColorGrey: 'A9A9A9',
    },
    {
      id: 56,
      name: 'Clients',
      size: 60,
      fillColor: 'A9A9A9',
      fillColorGrey: 'A9A9A9',
    },
    {
      id: 57,
      name: 'Engineers',
      size: 70,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 58,
      name: 'Designer',
      size: 80,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
    {
      id: 59,
      name: 'UX',
      size: 90,
      fillColor: 'F5BDBD',
      fillColorGrey: 'DCDCDC',
    },
  ];

  const loadWordCloudData = () => {
    setData(dt as unknown as Types.WordCloudData[]);
  };

  const currentWidthWords = isMobile ? 380 : width * 0.5;
  const currentHeightWords = isMobile ? 500 : height * 0.75;

  const currentWidthBubble = isMobile ? 440 : width * 0.5;
  const currentHeightBubble = isMobile ? 600 : height * 0.75;

  const currentTopBubble = isMobile ? -150 : 0;

  useEffect(() => {
    (dimensionsBubbleChart as unknown as { current: Types.Dimensions }).current =
      ChartHelper.getDimensions(currentWidthBubble, currentHeightBubble, 5, 5, currentTopBubble, 0);

    (dimensionsWordCloud as unknown as { current: Types.Dimensions }).current =
      ChartHelper.getDimensions(currentWidthWords, currentHeightWords, 10, 10, 0, 0);
  }, [width, height, dimensionsBubbleChart]);

  if (data.length <= 1) {
    loadWordCloudData();
  }

  useEffect(() => {
    if (updateContent) {
      let newSelectedIndex = selectedIndex + 1;
      if (newSelectedIndex > 1) {
        newSelectedIndex = 0;
      }
      if (newSelectedIndex !== selectedIndex) {
        setSelectedIndex(newSelectedIndex);
      }
    }
  }, [updateContent]);

  return (
    <>
      {data.length > 1 && dimensionsBubbleChart.current && (
        <Wrapper>
          {selectedIndex == 1 ? (
            <BubbleChart
              dimensions={dimensionsBubbleChart.current}
              data={isMobile ? data.slice(0, 25) : data}
              propertiesNames={['name', 'size']}
              wordsPadding={3}
              isLightsOn={isLightsOn}
            />
          ) : (
            <WordCloud
              dimensions={dimensionsWordCloud.current}
              data={data}
              propertiesNames={['value', 'name']}
              isLightsOn={isLightsOn}
            />
          )}
        </Wrapper>
      )}
    </>
  );
};
export default WordsBubblesWidget;

interface IWordsBubblesWidgetProps {
  updateContent: boolean;
  isLightsOn: boolean;
}
